/* eslint-disable react/no-children-prop */
import { Redirect, Route, Switch } from 'react-router-dom';

import PropTypes from 'prop-types';
import React from 'react';
import SignIn from './SignIn';
import SignInConfirm from './SignInConfirm';
import UnauthenticatedPaths from '../../../routing/UnauthenticatedRoutes/UnauthenticatedRoutes.paths';
import { connect } from 'react-redux';
import { mapStateToProps } from './SignInRoutes.container';

// eslint-disable-next-line no-use-before-define
export default connect(mapStateToProps)(SignInRoutes);

export function SignInRoutes(props) {
    const { needsSignInConfirmed } = props;

    let initialRoute = null;

    if (needsSignInConfirmed) {
        initialRoute = `${UnauthenticatedPaths.SIGN_IN_CONFIRM}`;
    }

    return (
        <Switch>
            {initialRoute && <Route children={<Redirect to={initialRoute} />} />}
            <Route exact path={UnauthenticatedPaths.SIGN_IN_CONFIRM} children={<SignInConfirm />} />
            <Route exact path={`${UnauthenticatedPaths.SIGN_IN}`} children={<SignIn />} />
            <Route children={<Redirect to={UnauthenticatedPaths.SIGN_IN} />} />
        </Switch>
    );
}

SignInRoutes.propTypes = {
    needsSignInConfirmed: PropTypes.bool,
};
